module.exports = SPAUI_BUSINESS;